var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',[_c('div',{staticClass:"site-width bs-grid"},[_c('p',{staticClass:"bs-grid-col-12"},[_vm._v("Copyright © 2002 - "+_vm._s(_vm.currentYear)+" Blue Sphere Studios")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }